<template>

	<div id="cotizar">

	  <!-- pasos -->
	  <div id="steps">

	  	<div class="step">
	  		<div class="step-content-icon">
	  			<v-icon class="step-icon">mdi-package-variant</v-icon>
	  		</div>
	  		<p class="step-text"><small>COTIZA</small></p>
	  	</div>

	  	<div class="step">
	  		<div class="step-content-icon">
	  			<v-icon class="step-icon">mdi-domain</v-icon>
	  		</div>
	  		<p class="step-text">
	  			<small>PAQUETERÍA</small>
	  		</p>
	  	</div>

	  	<div class="step">
	  		<div class="step-content-icon">
	  			<v-icon class="step-icon">mdi-account-plus</v-icon>
	  		</div>
	  		<p class="step-text"><small>REGISTRATE</small></p>
	  	</div>

	  	<div class="step">
	  		<div class="step-content-icon">
	  			<v-icon class="step-icon">mdi-send</v-icon>
	  		</div>
	  		<p class="step-text"><small>ENVÍA</small></p>
	  	</div>

	  	<div class="step" style="margin-right: 0px !important">
	  		<div class="step-content-icon">
	  			<v-icon class="step-icon">mdi-tab-search</v-icon>
	  		</div>
	  		<p class="step-text"><small>MONITOREA</small></p>
	  	</div>
	      
	  </div>


	  <!-- form -->
	  <div id="quote">
	  	<form class="mt-5 mb-5" @submit.prevent="cotizar()">	
	  		<v-container>
	  			<v-row>
	  			  <v-col offset-md="2" md="8" offset-sm="1" sm="10">
	  			  	<v-card id="quote-card">
  			  			<h2 class="mb-5 text-center" style="color: white;">Cotizar envío</h2>

  			  			<v-row>
  			  			  <v-col sm="6" cols="12" class="pb-0">
  			  			    <v-text-field label="Código postal de origen" solo v-model="quote.origin_postal_code" required maxlength="5"></v-text-field>
  			  			  </v-col>
  			  			  <v-col sm="6" cols="12" class="pb-0">
  			  			    <v-text-field label="Código postal de destino" solo v-model="quote.destination_postal_code" required maxlength="5"></v-text-field>
  			  			  </v-col>
  			  			</v-row>

  			  		  <v-row>
  			  		    <v-col cols="6">
  			  		      <v-text-field type="number" label="Peso (kg)" solo v-model="quote.peso" required min="1" max="5"></v-text-field>
  			  		    </v-col>
  			  		    <v-col cols="6">
  			  		      <v-text-field type="number" label="Largo (cm)" solo v-model="quote.largo" required max="115"></v-text-field>
  			  		    </v-col>
  			  		  </v-row>
  			  		  <v-row>
  			  		    <v-col cols="6">
  			  		      <v-text-field type="number" label="Ancho (cm)" solo v-model="quote.ancho" required max="115"></v-text-field>
  			  		    </v-col>
  			  		    <v-col cols="6">
  			  		      <v-text-field type="number" label="Alto (cm)" solo v-model="quote.alto" required max="115"></v-text-field>
  			  		    </v-col>
  			  		  </v-row>
  			  		  <div class="text-center mt-4 mb-5">
  			  		  	
  			  		  	<v-btn type="submit" rounded x-large dark block :disabled="disabledCotizar">
  			  		  		
  			  		  		<v-progress-circular
		  		  		      indeterminate
		  		  		      size="18"
		  		  		      width="4"
		  		  		      color="primary"
		  		  		      class="me-2 mb-1"
		  		  		      v-if="disabledCotizar"
		  		  		    ></v-progress-circular>
  			  		  			
  			  		  		COTIZAR
  			  		  	</v-btn>
  			  		  
  			  		  </div>
	  			  	</v-card>
	  			  </v-col>
	  			</v-row>
	  		</v-container>
	  	</form>
	  </div>
	  <!--/ form -->


	  <!-- packages -->
	  <v-dialog
      transition="dialog-top-transition"
      max-width="600"
      style="z-index: 1000;"
    >

    	<template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          v-bind="attrs"
          v-on="on"
          style="display: none;"
          id="btn-open-packages"
        >From the top</v-btn>
      </template>

      <template v-slot:default="showPackages">
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >Selecciona una paquetería</v-toolbar>
          
          <v-card-text>
            
          	<v-simple-table class="mt-10">
        	    <template v-slot:default>
        	    	<thead>
        	    		<tr>
        	    			<th>Paquetería</th>
        	    			<th>Tipo de servicio</th>
        	    			<th>Tiempo de entrega</th>
        	    			<th>Precio</th>
        	    		</tr>
        	    	</thead>
        	      <tbody>
        	        <tr 
        	        	v-for="item in packages" 
        	        	style="cursor:pointer;" 
        	        	@click="selecPackage(item.id)"
        	        	v-if="item.serviceType.serviceType == 'ECOEXPRESS'"
        	        >
        	          <td>
        	          	<img src="@/assets/img/redpack.png" height="25" />
        	          </td>
        	          <td>{{ item.serviceType.serviceType }}</td>
        	          <td>{{item.deliveryTime}} horas</td>
        	          <td>$. {{formatPrice(item.rate)}}</td>
        	        </tr>
        	      </tbody>
        	    </template>
        	  </v-simple-table>

          </v-card-text>
          
          <v-card-actions class="justify-end">
            <v-btn
              text
              @click="showPackages.value = false"
            >Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>


	</div>

</template>


<style>

	#cotizar {
		padding-top: 25px;
		padding-bottom: 25px;
		background: #f4f4f4;
	}


	#steps {
		margin-top: 25px;
		margin-bottom: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.step {
		margin-right: 70px;
	}

	.step-content-icon {
		box-shadow: 3px 3px 3px 3px #d0d0d0;
		background: #151515;
		border-radius: 100%;
		padding: 25px;
	}

	.step-icon {
		font-size: 50px !important;
		color: white !important;
	}

	.step-text {
		margin-top: 10px;
		font-weight: bold;
		color: black;
	}

	@media(max-width: 768px) {

		.step {
			margin-right: 40px;
		}

		.step-content-icon {
			padding: 20px;
		}

		.step-icon {
			font-size: 30px !important;
		}

		.step-text {
			display: none;
		}

	}

	@media(max-width: 425px) {

		.step {
			margin-right: 20px;
		}

		.step-content-icon {
			padding: 15px;
		}

		.step-icon {
			font-size: 30px !important;
		}

	}

	@media(max-width: 375px) {

		#steps {
			display: none;
		}

	}

	@media(max-width: 320px) {

		.step {
			margin-right: 15px;
		}

		.step-content-icon {
			padding: 10px;
		}

		.step-icon {
			font-size: 25px !important;
		}

	}


	#quote-card {
		background: #151515;
		box-shadow: 4px 4px 3px 4px #d0d0d0;
		padding: 20px;
	}

</style>


<script>
	
	import SendService from '@/shared/services/SendService'
	import PackageService from '@/shared/services/PackageService'

	export default
	{
		data() {
			return {
				quote: {
					origin_postal_code: null,
					destination_postal_code: null,
					peso: null,
					largo: null,
					ancho: null,
					alto: null
				},

				disabledCotizar: false,

				showPackages: false,

				packages: [],

				percUtility: 0
			}
		},

		created() {
			
		},

		methods: {

			async cotizar()
			{
				this.disabledCotizar = true

				const resp = await PackageService.getPricesSend(this.quote)

				console.log(resp.data)

				
				if(resp.data.packages[0].resultWS[0].status == 1)
				{
					this.packages = resp.data.packages[0].values
					this.percUtility = resp.data.percUtility

					$('#btn-open-packages').click()
				}
				else
				{
					SwalAlert('', resp.data[0].resultWS[0].description, 'error')
				}


				this.disabledCotizar = false
			},


			selecPackage(id)
			{
				this.$router.push('/autenticacion/') 
			},


			formatPrice(rate) 
			{
				rate = parseFloat(rate) 
				return (rate + (rate * this.percUtility / 100)).toFixed(2)
			}


		}

	}

</script>